module.exports = __webpack_public_path__ + "static/img/cabinet12_5.ceff8534.gif";